import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://hksugfgjntvitayrdlvb.supabase.co'  // replace with your Supabase URL
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhrc3VnZmdqbnR2aXRheXJkbHZiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTgwMjIyNjcsImV4cCI6MjAzMzU5ODI2N30.hBMzWjWaLXgrMJZKE1gxQnwx0DmAOlaD9UHtTqvsfMg' // replace with your Supabase key
export const supabase = createClient(supabaseUrl, supabaseKey)
